export const consolidationConfig = {
  enableConsolidation: false,
  inheritableFields: [
    'origin',
    'destination',
    'originLocationCode',
    'originLocationName',
    'destinationLocationCode',
    'destinationLocationName',
    'internationalCarrier',
    'shippingLine',
    'transportMode',
    'milestones.etd',
    'milestones.eta',
    'milestones.portOfLoading',
    'milestones.portOfDischarge',
    'milestones.vessel',
    'milestones.voyage'
  ]
};
